import { useEffect, useRef } from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useViewportDevice } from '@zep/react';
import { Dialog, DialogContent, DialogHeader, DialogOverlay, DialogPanel, DialogTitle } from '@zep/ui';
import { parseYoutubeUrl } from '@zep/utils';
import { createYoutubePlayer } from '../../../utils';
const ExploreYoutubeModalInner = (props: {
  url: string;
  title: string;
}) => {
  const {
    url,
    title
  } = props;
  const {
    visible,
    remove
  } = useModal();
  const playerDom = useRef<HTMLDivElement>(null);
  const {
    isMobile
  } = useViewportDevice();
  useEffect(() => {
    if (visible) {
      const {
        videoId: youtubeId
      } = parseYoutubeUrl(url);
      createYoutubePlayer({
        elementId: `reference-youtube`,
        // @ts-ignore
        youtubeId,
        url
      });
    }
  }, [url, visible]);
  return <Dialog open={true} onClose={remove} maxWidth={'800px'} height={isMobile ? '280px' : '512px'} data-sentry-element="Dialog" data-sentry-component="ExploreYoutubeModalInner" data-sentry-source-file="ExploreYoutubeModal.tsx">
      <DialogOverlay data-sentry-element="DialogOverlay" data-sentry-source-file="ExploreYoutubeModal.tsx" />
      <DialogPanel data-sentry-element="DialogPanel" data-sentry-source-file="ExploreYoutubeModal.tsx">
        <DialogHeader onClose={remove} data-sentry-element="DialogHeader" data-sentry-source-file="ExploreYoutubeModal.tsx">
          <div>
            <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="ExploreYoutubeModal.tsx">{title}</DialogTitle>
          </div>
        </DialogHeader>
        <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="ExploreYoutubeModal.tsx">
          <div ref={playerDom} id={'reference-youtube'} style={{
          width: '100%',
          height: '100%'
        }}></div>
        </DialogContent>
      </DialogPanel>
    </Dialog>;
};
export const ExploreYoutubeModal = NiceModal.create(ExploreYoutubeModalInner);